exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5bb66a5a] .el-input-number .el-input__inner{text-align:left}", ""]);

// exports
